import { DynamicSettings } from "Components/admin/DynamicSettings";
import {
	ARGENTINIAN_CULTURE_CODE,
	BRASILIAN_CULTURE_CODE,
	BRITISH_CULTURE_CODE,
	CHILEAN_CULTURE_CODE,
	COLOMBIAN_CULTURE_CODE,
	DOMINICA_CULTURE_CODE,
	ECUADORIAN_CULTURE_CODE,
	PARAGUAYAN_CULTURE_CODE,
	PERUVIAN_CULTURE_CODE,
	PROMO_CODE_URL_KEYS,
	URUGUAYAN_CULTURE_CODE,
	USA_CULTURE_CODE,
} from "Services/constants";
import { MappedUserInfo } from "Shared/models/MappedUserInfo";

export const decode = (input: string) => input.replace(/&#(\d+);/g, (_, dec) => String.fromCharCode(dec));

const getPromoCodesFromUrl = () => {
	const urlElems = window.location.href.split("?");

	if (urlElems.length < 2) return undefined;

	const queryElems = urlElems[1].split("&");

	const promoCodes = [];
	for (const elem of queryElems) {
		const [key, value] = elem.split("=");
		if (PROMO_CODE_URL_KEYS.includes(key.toLowerCase())) promoCodes.push(value);
	}

	return promoCodes;
};

const getDynamicPromoCode = (userInfo: MappedUserInfo, culture: string, dynamicSettings: DynamicSettings) => {
	// DEVNOTE: The sorting is because BancoEstado (BEC-...) is stronger than DC (DCB-...)
	const sortedSettings = dynamicSettings.DynamicPromoCodeSettings.sort((a, b) =>
		a.ProgramCodeAndLevel > b.ProgramCodeAndLevel ? 1 : -1
	);

	if (userInfo?.ProgramCodesWithLevels && userInfo.ProgramCodesWithLevels.length > 0) {
		const promoCode = sortedSettings.find(
			(item) =>
				item.ProgramCodeAndLevel &&
				(!item.Culture || item.Culture.toLowerCase() === culture.toLowerCase()) &&
				(!item.RoleCode || item.RoleCode.toLowerCase() === userInfo?.RoleCode?.toLowerCase()) &&
				userInfo.ProgramCodesWithLevels.some(
					(pcwl) => item.ProgramCodeAndLevel === `${pcwl.ProgramCode}-${pcwl.ProgramLevel}`
				)
		)?.Code;

		if (promoCode) return promoCode;
	}

	const promoCode = sortedSettings.find(
		(item) =>
			!item.ProgramCodeAndLevel &&
			(!item.Culture || item.Culture.toLowerCase() === culture.toLowerCase()) &&
			(!item.RoleCode || item.RoleCode.toLowerCase() === userInfo?.RoleCode?.toLowerCase())
	)?.Code;

	if (promoCode) return promoCode;

	return "";
};

const getDefaultPromoCode = (culture: string, dynamicSettings: DynamicSettings) => {
	switch (culture.toLowerCase()) {
		case CHILEAN_CULTURE_CODE:
			return dynamicSettings.DefaultPromotionCodeCl;
		case PERUVIAN_CULTURE_CODE:
			return dynamicSettings.DefaultPromotionCodePe;
		case ARGENTINIAN_CULTURE_CODE:
			return dynamicSettings.DefaultPromotionCodeAr;
		case COLOMBIAN_CULTURE_CODE:
			return dynamicSettings.DefaultPromotionCodeCo;
		case USA_CULTURE_CODE:
			return dynamicSettings.DefaultPromotionCodeUs;
		case BRASILIAN_CULTURE_CODE:
			return dynamicSettings.DefaultPromotionCodeBr;
		case PARAGUAYAN_CULTURE_CODE:
			return dynamicSettings.DefaultPromotionCodePy;
		case URUGUAYAN_CULTURE_CODE:
			return dynamicSettings.DefaultPromotionCodeUy;
		case ECUADORIAN_CULTURE_CODE:
			return dynamicSettings.DefaultPromotionCodeEc;
		case DOMINICA_CULTURE_CODE:
			return dynamicSettings.DefaultPromotionCodeDo;
		case BRITISH_CULTURE_CODE:
			return dynamicSettings.DefaultPromotionCodeGb;
		default:
			return "";
	}
};

const getDefaultSuperPromoCode = (culture: string, dynamicSettings: DynamicSettings) =>
	dynamicSettings.DefaultSuperPromoCodeSettings?.find(
		(setting) => setting.Culture.toLowerCase() === culture.toLowerCase()
	)?.Code || "";

export const getPromoCodes = (userInfo: MappedUserInfo, culture: string, dynamicSettings: DynamicSettings) => {
	const promoCodesFromUrl = getPromoCodesFromUrl();
	if (promoCodesFromUrl && promoCodesFromUrl.length > 0) return promoCodesFromUrl;

	if (!dynamicSettings) return [];

	// DEVNOTE: Navitaire dynamic promo code
	const dynamicPromoCode = getDynamicPromoCode(userInfo, culture, dynamicSettings);

	// DEVNOTE: Navitaire default promo code
	const defaultPromoCode = getDefaultPromoCode(culture, dynamicSettings);

	// DEVNOTE: Default super promo code
	const defaultSuperPromoCode = getDefaultSuperPromoCode(culture, dynamicSettings);

	const promoCodes = [dynamicPromoCode || defaultPromoCode || "", defaultSuperPromoCode].filter((code) => code);
	return promoCodes;
};
